import React from 'react'

export const ArrowRight: React.FC = () => {
  return (
    <path d="M10.1875 8.28125C10.3438 8.125 10.3438 7.90625 10.2188 7.75L6.53125 4.125C6.375 3.96875 6.125 3.96875 6 4.125L5.78125 4.34375C5.625 4.5 5.625 4.71875 5.78125 4.875L8.96875 8L5.78125 11.1562C5.625 11.3125 5.625 11.5312 5.78125 11.6875L6 11.9062C6.125 12.0625 6.375 12.0625 6.53125 11.9062L10.1875 8.28125Z" />
  )
}

export default ArrowRight
